import React, { useState, useEffect } from 'react';
import { Star, User, MapPin, ChevronDown, Users, Check } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBooking } from './BookingContext'; // Make sure this path is correct
import urbania from "../Assets/urbania.jpg"
import crysta from "../Assets/front-left-side-47 (2).png"
import tempo from "../Assets/tempo5-removebg-preview.png"
import bus from "../Assets/0e6573b4bab4e5af6fee5377e2f94aaf-removebg-preview.png"
import ertiga from "../Assets/ertiga (1).png"

const VehicleSelection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { bookingData, setBookingData } = useBooking(); // Now using actual hook
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedSeater, setSelectedSeater] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({
    from: '',
    to: '',
    pickupDate: '',
    tripType: ''
  });

  useEffect(() => {
    if (location.state) {
      setBookingDetails(location.state);
    }
  }, [location.state]);

  // Enhanced vehicle data with explicit seater information
  const vehicleCategories = {
    urbania: [
      {
        id: 1,
        name: 'Urbania',
        type: '16 Seater AC',
        category: 'urbania',
        seaters: 16,
        rating: 5.0,
        kms: 300,
        postLimit: 43,
        perKmPrice: 43,
        charges: 1299,
        features: ['AC', 'Comfort Seats', 'Ample Luggage Space']
      },
      {
        id: 2,
        name: 'Urbania',
        type: '12 Seater AC',
        category: 'urbania',
        seaters: 12,
        rating: 5.0,
        kms: 300,
        postLimit: 39,
        perKmPrice: 39,
        charges: 1199,
        features: ['AC', 'Comfort Seats', 'Ample Luggage Space']
      },
      {
        id: 3,
        name: 'Urbania',
        type: '9 Seater AC',
        category: 'urbania',
        seaters: 9,
        rating: 5.0,
        kms: 300,
        postLimit: 55,
        perKmPrice: 55,
        charges: 1099,
        features: ['AC', 'Comfort Seats', 'Ample Luggage Space']
      }
    ],
    innova: [
      {
        id: 4,
        name: 'Toyota Innova Hybrid',
        type: '7 Seater AC',
        category: 'innova',
        seaters: 7,
        rating: 5.0,
        kms: 300,
        postLimit: 24,
        perKmPrice: 24,
        charges: 999,
        features: ['Hybrid', 'AC', 'Premium Interior']
      },
      {
      id: 1,
      name: 'Toyota Innova Crysta',
      type: '7 Seater AC',
      category: 'innova',
      seaters: 7,
      rating: 5.0,
      kms: 300,
      postLimit: 20,
      perKmPrice: 20,
      charges: 999,
      features: ['Premium AC', 'Leather Seats', 'Bluetooth']
    },
     {
      id: 5,
      name: 'Maruti Suzuki Ertiga',
      type: '6 Seater MPV',
      category: 'suv',
      seaters: 6,
      rating: 5.0,
      kms: 130,
      postLimit: 17,
      perKmPrice: 17,
      charges: 899,
      features: ['AC', 'Power Steering', 'Music System']
    },
    ],
    tempo: [
      {
        id: 5,
        name: 'Tempo Traveller',
        type: '12 Seater AC',
        category: 'tempo',
        seaters: 12,
        rating: 5.0,
        kms: 300,
        postLimit: 24,
        perKmPrice: 24,
        charges: 1199,
        features: ['AC', 'Spacious', 'Reliable']
      },
      {
        id: 6,
        name: 'Tempo Traveller',
        type: '9 Seater AC',
        category: 'tempo',
        seaters: 9,
        rating: 5.0,
        kms: 300,
        postLimit: 30,
        perKmPrice: 30,
        charges: 1099,
        features: ['AC', 'Spacious', 'Reliable']
      }
    ],
    bus: [
      {
        id: 7,
        name: 'Bus',
        type: '50 Seater AC',
        category: 'bus',
        seaters: 50,
        rating: 5.0,
        kms: 300,
        postLimit: 70,
        perKmPrice: 70,
        charges: 2599,
        features: ['AC', 'Restroom', 'Luggage Compartment']
      },
      {
        id: 8,
        name: 'Bus',
        type: '40 Seater AC',
        category: 'bus',
        seaters: 40,
        rating: 5.0,
        kms: 300,
        postLimit: 65,
        perKmPrice: 65,
        charges: 2299,
        features: ['AC', 'Restroom', 'Luggage Compartment']
      },
      {
        id: 9,
        name: 'Bus',
        type: '30 Seater AC',
        category: 'bus',
        seaters: 30,
        rating: 5.0,
        kms: 300,
        postLimit: 55,
        perKmPrice: 55,
        charges: 1999,
        features: ['AC', 'Comfort Seats', 'Luggage Space']
      },
      {
        id: 10,
        name: 'Bus',
        type: '20 Seater AC',
        category: 'bus',
        seaters: 20,
        rating:5.0,
        kms: 300,
        postLimit: 40,
        perKmPrice: 40,
        charges: 1699,
        features: ['AC', 'Comfort Seats', 'Luggage Space']
      }
    ]
  };

  // Get vehicles based on selected category
  const getFilteredVehicles = () => {
    let vehicles = [];
    
    if (selectedCategory === 'all') {
      vehicles = Object.values(vehicleCategories).flat();
    } else {
      vehicles = vehicleCategories[selectedCategory] || [];
    }
    
    // Filter by seater if selected
    if (selectedSeater) {
      return vehicles.filter(vehicle => vehicle.seaters === selectedSeater);
    }
    
    return vehicles;
  };

  const calculateTotalPrice = (vehicle) => {
    const basePrice = vehicle.perKmPrice * vehicle.kms;
    return Math.round(basePrice + vehicle.charges);
  };

 const handleVehicleSelect = (vehicle) => {
  const totalPrice = calculateTotalPrice(vehicle);
  
  // Get current booking details from context and state
  const currentBookingData = bookingData || {};
  const currentBookingDetails = bookingDetails || {};
  
  // Update booking context with ALL trip data
  setBookingData({
    // Preserve existing booking data
    ...currentBookingData,
    
    // Update with vehicle details
    selectedVehicle: vehicle,
    totalPrice: totalPrice,
    
    // Get route details from bookingDetails (from location.state)
    from: currentBookingDetails.from || currentBookingData.from || '',
    to: currentBookingDetails.to || currentBookingData.to || '',
    pickupDate: currentBookingDetails.pickupDate || currentBookingData.pickupDate || '',
    tripType: currentBookingDetails.tripType || currentBookingData.tripType || 'oneWay',
    
    // Add additional derived fields
    fromCity: (currentBookingDetails.from || currentBookingData.from || '').split(',')[0],
    toCity: (currentBookingDetails.to || currentBookingData.to || '').split(',')[0],
    
    // Set default time if not provided
    pickupTime: currentBookingData.pickupTime || '10:00 AM',
    
    // Add timestamp
    selectedAt: new Date().toISOString()
  });
  
  navigate('/contact-details');
};

  // Get available seaters for the selected category
  const getAvailableSeaters = () => {
    if (selectedCategory === 'all') {
      const allSeaters = Object.values(vehicleCategories)
        .flat()
        .map(v => v.seaters);
      return [...new Set(allSeaters)].sort((a, b) => a - b);
    }
    
    if (vehicleCategories[selectedCategory]) {
      const seaters = vehicleCategories[selectedCategory]
        .map(v => v.seaters);
      return [...new Set(seaters)].sort((a, b) => a - b);
    }
    
    return [];
  };

  const handleSeaterSelect = (seater) => {
    if (selectedSeater === seater) {
      setSelectedSeater(null);
    } else {
      setSelectedSeater(seater);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header - Mobile Optimized */}
      <div className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 py-2 sm:py-3">
          <div className="flex justify-between items-center mb-2">
            <button
              onClick={() => navigate('/')}
              className="text-gray-500 hover:text-gray-700 text-xs sm:text-sm font-medium flex items-center gap-1"
            >
              ← Back
            </button>
            <span className="text-gray-500 text-xs">Select Vehicle</span>
          </div>
          
          {/* Route and Details - Mobile Responsive */}
          <div className="flex flex-col gap-2">
            <h2 className="text-base sm:text-lg md:text-xl font-bold text-gray-900">
              {bookingDetails.from || 'Bangalore'} → {bookingDetails.to || 'Select destination'}
            </h2>
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <div className="bg-gray-100 px-2 py-1 rounded">
                <span className="text-gray-500">Type:</span>
                <span className="ml-1 font-medium">{bookingDetails.tripType}</span>
              </div>
              <div className="bg-gray-100 px-2 py-1 rounded">
                <span className="text-gray-500">Pick-up:</span>
                <span className="ml-1 font-medium">{bookingDetails.pickupDate}</span>
              </div>
              <button 
                onClick={() => navigate('/')}
                className="text-cyan-500 hover:text-cyan-600 text-xs font-medium underline"
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Category Filters - Mobile Optimized with Scroll */}
      <div className="bg-white py-2 sm:py-3 border-b">
        <div className="max-w-5xl mx-auto px-3">
          {/* Horizontal scrollable on mobile */}
          <div className="overflow-x-auto pb-2 -mx-3 px-3">
            <div className="flex gap-2 min-w-max sm:min-w-0 sm:flex-wrap mb-2">
              <button
                onClick={() => {
                  setSelectedCategory('all');
                  setSelectedSeater(null);
                }}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === 'all' 
                  ? 'bg-cyan-500 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                All Vehicles
              </button>
              <button
                onClick={() => {
                  setSelectedCategory('urbania');
                  setSelectedSeater(null);
                }}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === 'urbania' 
                  ? 'bg-cyan-500 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Urbania
              </button>
              <button
                onClick={() => {
                  setSelectedCategory('innova');
                  setSelectedSeater(null);
                }}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === 'innova' 
                  ? 'bg-cyan-500 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Innova Hybrid
              </button>
              <button
                onClick={() => {
                  setSelectedCategory('tempo');
                  setSelectedSeater(null);
                }}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === 'tempo' 
                  ? 'bg-cyan-500 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Tempo Traveller
              </button>
              <button
                onClick={() => {
                  setSelectedCategory('bus');
                  setSelectedSeater(null);
                }}
                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === 'bus' 
                  ? 'bg-cyan-500 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                Buses
              </button>
            </div>
          </div>

          {/* Seater Filters - Mobile Optimized */}
          {selectedCategory !== 'innova' && (
            <div className="mt-2">
              <div className="text-xs text-gray-500 mb-1.5">Filter by Seater:</div>
              <div className="overflow-x-auto pb-2 -mx-3 px-3">
                <div className="flex gap-1.5 min-w-max sm:min-w-0 sm:flex-wrap">
                  {getAvailableSeaters().map((seater) => (
                    <button
                      key={seater}
                      onClick={() => handleSeaterSelect(seater)}
                      className={`px-2.5 sm:px-3 py-1.5 rounded-md text-xs font-medium flex items-center gap-1 transition-all whitespace-nowrap ${
                        selectedSeater === seater
                        ? 'bg-orange-100 text-orange-600 border border-orange-300'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      <Users size={12} />
                      {seater} Seater
                      {selectedSeater === seater && <Check size={12} />}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Vehicle Cards - Mobile Optimized */}
      <div className="max-w-5xl mx-auto px-2 sm:px-3 py-3 sm:py-4">
        {getFilteredVehicles().length === 0 ? (
          <div className="text-center py-8">
            <div className="text-4xl mb-2">🚗</div>
            <p className="text-gray-500 text-sm">No vehicles found for the selected filters</p>
            <button
              onClick={() => {
                setSelectedSeater(null);
                setSelectedCategory('all');
              }}
              className="mt-3 text-cyan-600 hover:text-cyan-700 text-sm font-medium"
            >
              Clear filters
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            {getFilteredVehicles().map((vehicle) => {
              const totalPrice = calculateTotalPrice(vehicle);
              
              return (
                <div
                  key={vehicle.id}
                  className="bg-white rounded-lg shadow-sm hover:shadow border border-gray-200 overflow-hidden"
                >
                  <div className="p-2.5 sm:p-3">
                    <div className="flex gap-2 sm:gap-3">
                      {/* Vehicle Image and Seater Badge - Mobile Optimized */}
                      <div className="w-20 sm:w-24 flex-shrink-0 relative">
                        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-md p-2 h-20 sm:h-28 flex flex-col items-center justify-center">
                          <img 
      src={vehicle.category === 'urbania' ? urbania : 
            vehicle.category === 'bus' ? bus: 
            vehicle.category === 'tempo' ? tempo : 
            vehicle.category === 'innova' ? crysta : 
            vehicle.category === 'suv' ? ertiga :
            'innova-placeholder-url'}
      alt={`${vehicle.name} ${vehicle.type}`}
      className="w-full h-full object-cover"
    />
                          <div className="text-xs text-gray-600 font-medium truncate text-center w-full px-1">
                            {vehicle.name}
                          </div>
                        </div>
                        
                        {/* Seater Badge */}
                        <div className="absolute -top-1 -right-1 bg-cyan-500 text-white rounded-full w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center text-xs font-bold shadow-sm">
                          {vehicle.seaters}
                        </div>
                      </div>

                      {/* Vehicle Details - Mobile Optimized */}
                      <div className="flex-1 flex flex-col justify-between min-w-0">
                        <div>
                          {/* Title and Rating */}
                          <div className="flex items-start gap-1 mb-1">
                            <h3 className="text-base  sm:text-base  font-bold text-gray-900 flex-1 line-clamp-2">
                              {vehicle.name} • {vehicle.type}
                            </h3>
                            <span className="bg-gray-800 text-white px-1.5 py-0.5 rounded-full text-xs flex items-center gap-0.5 flex-shrink-0">
                              {vehicle.rating} <Star size={10} className="fill-white" />
                            </span>
                          </div>
                          
                          {/* Features - Mobile Optimized */}
                          <div className="flex flex-wrap gap-1 mb-1.5">
                            {vehicle.features.slice(0, 2).map((feature, index) => (
                              <span 
                                key={index}
                                className="text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded"
                              >
                                {feature}
                              </span>
                            ))}
                            {vehicle.features.length > 2 && (
                              <span className="text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded">
                                +{vehicle.features.length - 2}
                              </span>
                            )}
                          </div>
                          
                          {/* Driver and KM Info - Mobile Stacked */}
                          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 mb-1.5 text-xs text-gray-700">
                            <div className="flex items-center gap-1">
                              <User size={11} />
                              <span>Driver Included</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <MapPin size={11} />
                              <span className="truncate">{vehicle.kms} km • ₹{vehicle.postLimit}/km extra</span>
                            </div>
                          </div>
                        </div>

                        {/* Price and Button - Mobile Optimized */}
                        <div className="mt-2 flex flex-col sm:flex-row justify-between items-start sm:items-end gap-2">
                          {/* Price Section - Mobile Inline */}
                          <div className="flex items-center gap-2 sm:gap-3">
                            <div>
                              <div className="text-xs text-gray-500">Per Km</div>
                              <div className="text-base sm:text-lg font-bold text-cyan-600">
                                ₹{vehicle.perKmPrice}/km
                              </div>
                            </div>
                            {/* <div className="text-gray-300">|</div> */}
                            {/* <div>
                              <div className="text-xs text-gray-500">Base Fare</div>
                              <div className="text-sm font-semibold text-gray-700">
                                ₹{vehicle.charges}
                              </div>
                            </div> */}
                          </div>
                          
                          {/* Select Button - Full Width on Mobile */}
                          <button
                            onClick={() => handleVehicleSelect(vehicle)}
                            className="w-full sm:w-auto bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold py-2 sm:py-1.5 px-4 rounded-md text-xs shadow-sm hover:shadow transition-all"
                          >
                            SELECT VEHICLE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleSelection;